<script>
import { required } from 'vuelidate/lib/validators'

export default {
	props: {
		asset: {
			type: Object,
			required: true
		}
	},
	data() {
		return {

		}
	},
	methods: {
		formatSeverityText (severity) {
			let severityColor = {
				"high": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatTypeText (severity) {
			let severityColor = {
				"Malware": "color:#FF6780",
				"medium": "color:#FFC60B",
				"low": "color:#4DD8A8"
			}
			return severityColor[severity]
		},
		formatAction (action) {
			let actionColor = {
				"DETECTED": "color:rgb(26, 5, 214)",
				"BLOCKED_9": "color:#01AD00",
				"PREVENTED": "color:#01AD00"
			}
			return actionColor[action]
		}
	}
}
</script>

<template>
	<div>
		<div class="custom-control">
			<b>Name:</b>&nbsp;{{ asset.name }}
		</div> 
		<div class="custom-control">
			<b>Type:</b>&nbsp;{{ asset.manual_type.toUpperCase() }}
		</div> 
		<div v-if="asset.vip !== undefined && asset.vip.toUpperCase() === 'SI'" class="custom-control">
			<b>VIP:</b>&nbsp;
			<feather type="star" class="icon-dual-warning icon-xs mr-2 align-middle"></feather>
		</div>
		<div v-if="asset.desc !== undefined" class="custom-control">
			<b>Description:</b>&nbsp;{{ asset.desc }}
		</div> 
		<div v-if="asset.role !== undefined" class="custom-control">
			<b>Role:</b>&nbsp;{{ asset.role }}
		</div> 
		<div v-if="asset.os !== undefined" class="custom-control">
			<b>OS:</b>&nbsp;{{ asset.os }}
		</div> 
		<div v-if="asset.local_ip !== undefined" class="custom-control">
			<b>Local IP:</b>&nbsp;{{ asset.local_ip }}
		</div> 
		<div v-if="asset.global_ip !== undefined" class="custom-control">
			<b>Global IP:</b>&nbsp;{{ asset.global_ip }}
		</div> 
		<div v-if="asset.dns_name !== undefined" class="custom-control">
			<b>DNS Name:</b>&nbsp;{{ asset.dns_name }}
		</div> 
		<div v-if="asset.company !== undefined" class="custom-control">
			<b>Company:</b>&nbsp;{{ asset.company }}
		</div> 
		<div v-if="asset.division !== undefined" class="custom-control">
			<b>Division:</b>&nbsp;{{ asset.division }}
		</div> 
		<div v-if="asset.location !== undefined" class="custom-control">
			<b>Location:</b>&nbsp;{{ asset.location }}
		</div> 
		<div v-if="asset.datacenter !== undefined" class="custom-control">
			<b>Datacenter:</b>&nbsp;{{ asset.datacenter }}
		</div> 
		<div v-if="asset.user_fullname !== undefined" class="custom-control">
			<b>User Full Name:</b>&nbsp;{{ asset.user_fullname }}
		</div> 
		<div v-if="asset.app_responsable !== undefined" class="custom-control">
			<b>App Responsable:</b>&nbsp;{{ asset.app_responsable }}
		</div> 
		<div v-if="asset.serial !== undefined" class="custom-control">
			<b>Serial Number:</b>&nbsp;{{ asset.serial }}
		</div> 
	</div>
</template>

<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>